module.exports = __webpack_public_path__ + "static/comic-odyssey-screencast-af896ea3abf10948102736b5409a96d4.mp4";